import script from "./SynapBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SynapBlock.vue?vue&type=script&setup=true&lang=js"

import "./SynapBlock.vue?vue&type=style&index=0&id=e9fffefc&lang=scss"

const __exports__ = script;

export default __exports__